var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1060_685",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1060_685",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4FJREFUeNrMWbl21DAUldyFsPgAHU2mg7AZKCni+YP8A/shh4QSmjnTsENmDrT8w/xBNAVrCJiObtKwhc0d5ePJ20iyZUu2k+BzYmmeNfLVfe9djV4oqXGFH5/NYeNTQhcIJR4h1KOUP0FL1ER3bGiADf7RMZrY7PzlTdt3UZvBfz489fEbywhjkSiAFGAke5qOi00j7A9n5y+xVgH+fj9EYLSHg32ivFwCUQJ2CjJqESDt7zl2kTUC+Gtj4CbAVsyBFbpaB3aANw40tAb4c2PVxWnWsOuJrEgvLgFb7uppy2MU790ZDUinENy7VY8AmQABL7ZA0kDcg+RzYo+skPWk8aKViOMgG+fhffL303PPiMEf60/QrWSCa3QzdhT2Ul5y7NmyKI/jDHZmjl4ItQxurT92cVXcrW66Wmn1IosF7FmzKM4DgO8ka8ikq3cxkF4Uc5BNP51CYyM6G0iN1gbyHNzNvUIXb7195PMV6FyodbWt7JQnTBoSXXQ1kxiEFDnkiNHYqhOGiM41S5i07Uku/v7moY+jfCl2KmOwYAElLq9ytRKyPsaiLzK4LAWEkgi2CQMNEyYZF2Gi314/4Bv/JFN5IQaz2KiIxTpbn6E8dTiDvrQqUGJHkRHQxJZpDFrITuRqB80LakBAriPbKiXG0AaVsgMLDj71pNWXsKiNwe3JZG7znGgvhDLGLBOm5X3ayaM2kBNTm63EFNiczAWgrLpF2WmyTztgkRymLLa5TzuFcrLLsiN607GVmJ2QHfGpEx8LBdQWLG6/7JCAx2CgBlkV2B2UnYDH4Fjz41ElbzdkZ8xdzKDAhf+J7DDnyPnbvBwxqpMc2yk7SNpo7/Erm+nvwWGpnOyC7ESYUplBFlns6posNpadHFi278RVpp7q+nUyuR3ZySVRP3fsTFgcQI5GGWxVIjSWHYDB/pPXmK700Y+FOy87dZKjhuwERGCvsPTx+cUdNzmjuJVnFLFiVVEaMTjLhHjrHDh1PSwtHqGr+YAuripsQ3YMqxIhOrirgtNWtxBkgBN0Gu/TYBSD0bvc00uBcfktBnkrYpInjm7r00qMNgZzYPncXddbsi9giteXl3fxaEp7GDa+ppZiG4MM2/7BMzealYDV6+ure3584qeLNRNmhLfhobMr7RbR80DvzyVs8jO1h8A8TcYH2A3w0xhbdvjcTet/Q/wTYAAauYcKb5sbvwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGold);
export default __webpack_public_path__ + "static/media/yellow-gold.f31a7eafd071aab3a0980a77b8d0350b.svg";
export { ForwardRef as ReactComponent };